module.exports = __webpack_public_path__ + "img/home-fqa-2.df4fb27a.svg";